import { ExperienceVibe } from '@/types/gql.generated';
import { plannerVibe } from './planner.vibe';
import { summerVibe } from './summer.vibe';
import type { Vibe } from './vibe.types';

// Insertion order is meaningful: Object.values(VIBES) drives the vibe picker,
// so the default (Summer) is listed first.
export const VIBES: Record<ExperienceVibe, Vibe> = {
  [ExperienceVibe.Summer]: summerVibe,
  [ExperienceVibe.Planner]: plannerVibe,
};
